module.exports = __webpack_public_path__ + "resources/img/img_gamebase_nyangrila.3f9ab5d17d22d59a97f3618bcfa3a912.png";